import axios from '@/lib/axios'
import { buildAdminRequestConfig, type OrganizationId } from '@/lib/organization-scoping'
import type { PosCart } from '@/lib/services/carts/carts.types'
import type {
  ApplySalesOrderChangeInput,
  OpenedSalesOrderEditCart,
  SalesOrderChangeResult,
} from './sales-order-changes.types'

interface OrganizationScope {
  organizationId: OrganizationId
}

export interface RestoreSalesOrderChangeItemInput {
  salesOrderId: number
  cartId: number
  salesOrderItemId: number
}

export interface OpenSalesOrderEditCartInput {
  salesOrderId: number
  /** Discard this draft and start again from the order as it is; a repeat returns the draft that replaced it. */
  restartCartId?: number
}

export async function openSalesOrderEditCart({
  organizationId,
  salesOrderId,
  restartCartId,
}: OrganizationScope & OpenSalesOrderEditCartInput) {
  return axios.post<OpenedSalesOrderEditCart>(
    `/sales-orders/${salesOrderId}/edit-cart`,
    restartCartId ? { restart_cart_id: restartCartId } : null,
    buildAdminRequestConfig({ organizationId })
  )
}

/** Puts a removed item back in the draft as the order has it; answers with the POS cart. */
export async function restoreSalesOrderChangeItem({
  organizationId,
  salesOrderId,
  cartId,
  salesOrderItemId,
}: OrganizationScope & RestoreSalesOrderChangeItemInput) {
  return axios.post<PosCart>(
    `/sales-orders/${salesOrderId}/edit-cart/${cartId}/restored-items`,
    { sales_order_item_id: salesOrderItemId },
    buildAdminRequestConfig({ organizationId })
  )
}

export async function applySalesOrderChange({
  organizationId,
  salesOrderId,
  ...values
}: OrganizationScope & ApplySalesOrderChangeInput) {
  return axios.post<SalesOrderChangeResult>(
    `/sales-orders/${salesOrderId}/amendments`,
    values,
    buildAdminRequestConfig({ organizationId })
  )
}
